/*
 * Custom: complimentary-products upsell + slide-out cart trigger
 * -------------------------------------------------------------
 * In the v12 theme this logic lived inside the (unminified) empire.js
 * `_updateCart()` method, which also dispatched the custom `product:added`
 * event that opens cart-drawer.js. v13 ships empire.js minified/regenerated,
 * so that custom code was wiped. This standalone, upgrade-safe script restores
 * both behaviours WITHOUT editing empire.js:
 *
 *   1. After an add-to-cart (POST /cart/add), add any checked complimentary
 *      upsell products as separate line items.
 *   2. Dispatch `product:added` so the slide-out cart drawer (cart-drawer.js)
 *      opens and refreshes.
 *
 * Upsell checkboxes are rendered by snippets/complimentary-products.liquid:
 *   <input class="product-upsell__checkbox" value="{variant_id}">
 *
 * Detection: the theme adds to cart via jQuery.ajax (XMLHttpRequest), so we
 * observe XHR rather than replacing the theme's add-to-cart handling. If any
 * add path is found to use `fetch()` instead, extend this to patch fetch too.
 */
(function () {
  var ADD_URL =
    (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ||
    '/cart/add';

  // Guard so the upsell request we fire below does not re-trigger this flow.
  var addingUpsells = false;

  function getCheckedUpsells() {
    var boxes = document.querySelectorAll('.product-upsell__checkbox:checked');
    return Array.prototype.map
      .call(boxes, function (cb) {
        return { id: parseInt(cb.value, 10), quantity: 1 };
      })
      .filter(function (item) {
        return item.id;
      });
  }

  function notifyAdded(detail) {
    document.dispatchEvent(
      new CustomEvent('product:added', { detail: detail || {} })
    );
  }

  function handleCartAdd() {
    if (addingUpsells) return; // ignore our own upsell request completing

    var upsells = getCheckedUpsells();

    if (!upsells.length) {
      notifyAdded();
      return;
    }

    addingUpsells = true;
    fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: upsells })
    })
      .then(function (res) {
        return res.json();
      })
      .catch(function (err) {
        console.error('[custom-upsell] failed to add upsells', err);
      })
      .then(function () {
        addingUpsells = false;
        notifyAdded(); // refresh drawer once upsells are in the cart
      });
  }

  // --- Observe add-to-cart XHRs (theme uses jQuery.ajax -> XMLHttpRequest) ---
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__isCartAdd =
      typeof url === 'string' &&
      /\/cart\/add/.test(url) &&
      /post/i.test(method || '');
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__isCartAdd && !addingUpsells) {
      // Open the drawer immediately so it feels instant, before the network
      // round-trip completes. cart-drawer.js shows a loading state.
      document.dispatchEvent(new CustomEvent('cart:adding'));

      this.addEventListener('load', function () {
        // Defer a tick so the cart is settled before we read/add upsells.
        // Runs on success and failure so the drawer's loading state always clears.
        setTimeout(handleCartAdd, 0);
      });
    }
    return origSend.apply(this, arguments);
  };
})();
